<div class="modal-header">
  <h4 class="modal-title">{{'finalizeProject.popup.title' | translate}}</h4>
</div>

<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <form [formGroup]="form">
      <div class="mb-3 row">
        <label class="col-md-4 col-form-label"></label>
        <div class="col-md-8 col-form-label">
          @if (showGenerateArticleNumberElement && (mcsGds221LtlExport || markingSystemExport) && isCurrentArticleNumberLongEmpty) {
            <div class="form-check">
              <input [checked]="preselectGenerateArticleNumberElement" class="form-check-input" id="generateArticleNumber" type="checkbox" value="generateArticleNumber" (change)="updateArticleNumberLong($event.target.checked)">
              <label class="form-check-label" for="generateArticleNumber">{{'finalizeProject.label.generateArticleNumber' | translate}}</label>
            </div>
          }
        </div>
      </div>
      <div class="mb-3 row">
        @if (legacyExport && mcsGds221LtlExport) {
          <label class="col-md-4 col-form-label" >{{'finalizeProject.label.articleNumberLong' | translate}}: *</label>
        } @else {
          <label class="col-md-4 col-form-label" >{{'finalizeProject.label.articleNumber' | translate}}: *</label>
        }
        <div class="col-md-8" [class.form-inline]="!legacyExport && mcsGds221LtlExport">
          @if (!legacyExport && !mcsGds221LtlExport && !markingSystemExport) {
            <div class="input-group">
              <input class="form-control me-2" formControlName="{{articleNumberLongTextInputName}}" type="text" [class.is-invalid]="form.controls[articleNumberTextInputName]?.invalid">
              <span class="icon-container"><i class="fa fa-pencil-alt mt-2 c-pointer" [class.disabled]="articleNumberTextInputDisabled || !isCurrentArticleNumberLongEmpty" (click)="editArticleNumber()"></i></span>
              <div class="invalid-feedback">{{form.controls[articleNumberTextInputName]?.errors?.messageKey | translate: {'0': form.controls[articleNumberTextInputName]?.errors?.param} }}</div>
            </div>
          }
          @if (!isCurrentArticleNumberLongEmpty && mcsGds221LtlExport && !legacyExport) {
            <!-- mcs/gds -->
            <!-- currentArticleNumberLong present -->
            <div class="input-group">
              <input class="form-control me-2" formControlName="{{articleNumberLongTextInputName}}" type="text" [class.is-invalid]="form.controls[articleNumberTextInputName]?.invalid">
              <span class="icon-container"><i class="fa fa-pencil-alt mt-2 c-pointer" [class.disabled]="!isArticleNoEditable()" (click)="editArticleNumber()"></i></span>
              <div class="invalid-feedback">{{form.controls[articleNumberTextInputName]?.errors?.messageKey | translate: {'0': form.controls[articleNumberTextInputName]?.errors?.param} }}</div>
            </div>
          }
          @if (isCurrentArticleNumberLongEmpty) {
          <!-- currentArticleNumberLong not present -->
            @if (!legacyExport && (mcsGds221LtlExport || markingSystemExport)) {
              <input class="form-control" formControlName="{{articleNumberTextInputName}}" type="text"
                     inputRestricter="^[0-9A-Z-/]*$" maxlength="{{maxArticleNumberChars}}" (input)="updateArticleNumberLong()"
                     [class.is-invalid]="form.controls[articleNumberTextInputName]?.invalid">
            }
            @if (legacyExport) {
              <input class="form-control" formControlName="{{articleNumberTextInputLegacyName}}" type="text"
                     inputRestricter="^[0-9A-Z-/]*$" [class.is-invalid]="form.controls[articleNumberTextInputLegacyName]?.invalid">
            }
            @if (!legacyExport && mcsGds221LtlExport) {
              <label class="col-form-label">&nbsp;&nbsp;&#47;&nbsp;&nbsp;</label>
              <input class="form-control" formControlName="{{articleNumberExtensionInputName}}" type="text" (input)="updateArticleNumberLong()"
                     inputRestricter="^[0-9A-Z-/]*$" [class.is-invalid]="form.controls[articleNumberExtensionInputName]?.invalid">
            }
            @if (mcsGds221LtlExport || markingSystemExport) {
              <div class="invalid-feedback">
                {{form.controls[articleNumberTextInputName]?.errors?.messageKey | translate: {'0': form.controls[articleNumberTextInputName]?.errors?.param} }}
              </div>
            }
            @if (legacyExport) {
              <div class="invalid-feedback">
                {{form.controls[articleNumberTextInputLegacyName]?.errors?.messageKey | translate: {'0': form.controls[articleNumberTextInputLegacyName]?.errors?.param} }}
              </div>
            }

          }

        </div>
      </div>
      <!--
          drawing number input discontinued
      -->
      <div class="mb-3 row"><label class="col-md-4 col-form-label" for="text-input">{{'finalizeProject.label.typeClassId' | translate}}: *</label>
        <div class="col-md-8">
          <select id="typeClassIdSelect" class="form-control" formControlName="{{typeClassIdComboboxName}}" (change)="typeClassIdComboboxChangeHandler()" [class.is-invalid]="form.controls[typeClassIdComboboxName]?.invalid">
            @for (typeClass of typeClasses; track typeClass) {
              <option [ngValue]="typeClass.classId">{{typeClass.description}}</option>
            }
          </select>
          <div class="invalid-feedback">{{form.controls[typeClassIdComboboxName]?.errors?.messageKey | translate: {'0': form.controls[typeClassIdComboboxName]?.errors?.param} }}</div>
        </div>
      </div>
      <div class="mb-3 row"><label class="col-md-4 col-form-label" for="text-input">{{'finalizeProject.label.mainNote' | translate}}: *</label>
        <div class="col-md-8">
          <select id="mainNoteSelect" class="form-control" formControlName="{{mainNoteComboboxName}}" (change)="mainNoteComboboxNameChangeHandler()" [class.is-invalid]="form.controls[mainNoteComboboxName]?.invalid">
            @for (mainNote of mainNotes; track mainNote) {
              <option [ngValue]="mainNote.attributeId">{{mainNote.displayName}}</option>
            }
          </select>
          <div class="invalid-feedback">{{form.controls[mainNoteComboboxName]?.errors?.messageKey | translate: {'0': form.controls[mainNoteComboboxName]?.errors?.param} }}</div>
        </div>
      </div>
      @if (mcsGds221LtlExport) {
        <div class="mb-3 row"><label class="col-md-4 col-form-label" for="text-input">{{'finalizeProject.label.productFamily' | translate}}: *</label>
          <div class="col-md-8">
            <select id="productFamilySelect" class="form-control" formControlName="{{productFamilyComboboxName}}" [class.is-invalid]="form.controls[productFamilyComboboxName]?.invalid">
              @for (family of productFamilies; track family) {
                <option [ngValue]="family.attributeId">{{family.displayName}}</option>
              }
            </select>
            <div class="invalid-feedback">{{form.controls[productFamilyComboboxName]?.errors?.messageKey | translate: {'0': form.controls[productFamilyComboboxName]?.errors?.param} }}</div>
          </div>
        </div>
        @for (additionalNoteComboboxName of additionalNoteComboboxNames; track additionalNoteComboboxName; let i = $index) {
          <div class="mb-3 row"><label class="col-md-4 col-form-label" for="text-input">{{'finalizeProject.label.additionalNote' | translate}} {{(i + 1).toString().padStart(2, '0')}}:</label>
            <div class="col-md-8">
              <select id="additionalNote{{(i + 1).toString().padStart(2, '0')}}Select" class="form-control" formControlName="{{additionalNoteComboboxName}}" >
                @if (additionalNotes.length > i + 1) {
                  @for (additionalNote of additionalNotes[i + 1]; track additionalNote) {
                    <option [ngValue]="additionalNote.attributeId">{{additionalNote.displayName}}</option>
                  }
                }
              </select>
            </div>
          </div>
        }
      } @else {
        <div class="mb-3 row"><label class="col-md-4 col-form-label" for="text-input">{{'finalizeProject.label.additionalNotes' | translate}}:</label>
          <div class="col-md-8">
            <select id="additonalNoteSelect" class="form-control" formControlName="{{additionalNoteComboboxName}}" multiple style="min-height: 120px; background: none;">
              @if (additionalNotes.length > 0) {
                @for (additionalNote of (additionalNotes[0] || []); track additionalNote) {
                  <option [ngValue]="additionalNote.attributeId">{{additionalNote.displayName}}</option>
                }
              }
            </select>
            <div class="col-form-label">{{'finalizeProject.label.countryCodeMultiSelectHint' | translate}}</div>
          </div>
        </div>
      }
      <div class="mb-3 row"><label class="col-md-4 col-form-label" for="text-input">{{'finalizeProject.label.productionPlant' | translate}}: *</label>
        <div class="col-md-8">
          <select id="productionPlantSelect" class="form-control" formControlName="{{productionPlantComboboxName}}" [class.is-invalid]="form.controls[productionPlantComboboxName]?.invalid" (change)="updateCountryCodePreselection()">
            @for (productionPlant of productionPlants; track productionPlant) {
              <option [ngValue]="productionPlant.plantNo">{{getProductionPlantLabel(productionPlant)}}</option>
            }
          </select>
          <div class="invalid-feedback">{{form.controls[productionPlantComboboxName]?.errors?.messageKey | translate: {'0': form.controls[productionPlantComboboxName]?.errors?.param} }}</div>
        </div>
      </div>
      @if (!mcsGds221LtlExport && ! markingSystemExport) {
        <div class="mb-3 row"><label class="col-md-4 col-form-label" for="text-input">{{'finalizeProject.label.tariffNumber' | translate}}:</label>
          <div class="col-md-8">
            <select id="tariffNumberSelect" class="form-control" formControlName="{{tariffNumberComboboxName}}">
              @for (tariffNumber of tariffNumbers; track tariffNumber) {
                <option [ngValue]="tariffNumber.value">{{tariffNumber.value}}</option>
              }
            </select>
          </div>
        </div>
      }
      @if (isMdmGroupVisible) {
        <div class="mb-3 row">
          <label class="col-md-4 col-form-label" for="text-input">{{'finalizeProject.label.mdmGroup' | translate}}:</label>
          <div class="col-md-8">
            <select class="form-control w-25" formControlName="{{mdmGroupComboboxName}}" [compareWith]="compareMdmGroups">
              <option [ngValue]="null">{{'finalizeProject.label.mdmGroup.none' | translate}}</option>
              @for (mdmGroup of allMdmGroups(); track $index) {
                <option [ngValue]="mdmGroup">{{mdmGroup.name}}</option>
              }
            </select>
          </div>
        </div>
      }
      @if (isCountryCodeSelectorEnabled) {
        <div class="mb-3 row"><label class="col-md-4 col-form-label" for="countryCodeSelect">{{'finalizeProject.label.countryCode' | translate}}: *</label>
          <div class="col-md-8">
            <select multiple id="countryCodeSelect" class="form-control" formControlName="{{countryCodeComboboxName}}" [class.is-invalid]="form.controls[countryCodeComboboxName]?.invalid" style="min-height: 120px; background: none;" (change)="countryCodeSelectionChanged()">
              @for (countryCode of countryCodes; track countryCode) {
                <option [ngValue]="countryCode.countryCode">{{getCountryCodeLabel(countryCode)}}</option>
              }
            </select>
            <div class="invalid-feedback">{{form.controls[countryCodeComboboxName]?.errors?.messageKey | translate: {'0': form.controls[countryCodeComboboxName]?.errors?.param} }}</div>
            <div class="col-form-label">{{'finalizeProject.label.countryCodeMultiSelectHint' | translate}}</div>
          </div>
        </div>
      }

      <div class="mb-3 row"><label class="col-md-4 col-form-label" for="text-input">{{'finalizeProject.label.changeOrderNumber' | translate}}:</label>
        <div class="col-md-8">
          <div class="input-group">
            <div class="input-group-preppend"><span class="input-group-text">CO</span></div>
            <input class="form-control" formControlName="{{changeOrderNumberInputName}}" type="text" inputRestricter="^[0-9]*$" maxlength="8">
          </div>
        </div>
      </div>
      <div class="mb-3 row">
        <label class="col-md-4 col-form-label" for="text-input">{{'finalizeProject.label.stockSeparation' | translate}}:</label>
        <div class="col-md-8">
          <select class="form-control" formControlName="{{stockSeparationComboboxName}}">
            <option value=""></option>
            <option value="Ja">{{'global.label.yes' | translate}}</option>
            <option value="Nein">{{'global.label.no' | translate}}</option>
          </select>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary btn-cancel" (click)="close()">{{'global.label.cancel' | translate}}</button>
  <button type="button" class="btn btn-primary btn-forward" (click)="finalizeButtonClickHandler()" [disabled]="!validateForm()">{{'global.label.next' | translate}}</button>
</div>
